.money {
  font-variant-numeric: var(--numeric);
  white-space: nowrap;
}

.money[data-missing] {
  color: var(--color-text-subtle);
}

.unit {
  margin-inline-start: var(--space-1);
  color: var(--color-text-subtle);
  font-size: var(--text-xs);
}
